import { EncounterStatus } from '@hb/shared'
import { EncounterSurface } from './encounterSurface'

// §7.1 (decision 4, 2026-07-07): opening a FULL note is the loggable view event; the
// quick-auth summary is not. This predicate encodes the instruction table exactly:
//
//   Admin read-only view (full sections)            → log
//   Provider authenticated read-only view           → log
//   Provider EncounterForm on an existing note       → log  (Draft/Saved edit, amendment)
//   Quick-auth summary (providers app, COMPLETED)    → no
//   Quick-auth → tap through to the full form        → log  (surface flips to 'form')
//   Brand-new encounter (no examId)                  → no
//
// A "full note" is: any 'form' surface on an existing note, OR any 'view' surface that is
// NOT the quick-auth summary. The quick-auth summary is exactly the branch EncounterView
// renders as EncounterQuickAuthView — status COMPLETED with an onEdit callback present
// (providers app only; the admin app never passes onEdit, so it always sees full sections).
export const getShouldLogEncounterView = ({
  examId,
  surface,
  status,
  hasOnEdit,
}: {
  examId: string | null
  surface: EncounterSurface | null
  status?: EncounterStatus
  hasOnEdit: boolean
}): boolean => {
  if (!examId || !surface) return false
  const isQuickAuthSummary = surface === 'view' && status === EncounterStatus.COMPLETED && hasOnEdit
  return !isQuickAuthSummary
}
